export default __webpack_public_path__ + "static/media/background2.2d7e64cd.jpg";